import { Routes } from '@angular/router';
import { MockPositionComponent } from './mock-position.component';

export const MockPositionRouting: Routes = [
  {
    path: '',
    component: MockPositionComponent
  },
];
